import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "sseuropa_anon_id";

function getAnonId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = `anon-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}

export default function VisitorTracker() {
  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    // Skip admin & internal routes
    if (location.pathname.startsWith("/admin")) return;
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    const lang = localStorage.getItem("sseuropa_lang") || "it";
    axios.post(`${API}/track/visit`, {
      anon_id: getAnonId(),
      path: location.pathname,
      lang,
      referrer: document.referrer || null,
    }).catch(() => {});
  }, [location.pathname]);

  return null;
}
